











// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";

export default defineComponent({
	props:{
		enabled:{
			type:Boolean,
			default:false,
		}
	},
	components:{
	},
	setup(props){

		const variant = computed(() => props.enabled ? "success" : "secondary");
		const label = computed(() => props.enabled ? "Live" : "Closed");

		return {
			variant,
			label,
		};
	}
});

